<template>
  <Tab @close="removeCurrent">
    <template #toolbar-help>
      <v-btn class="tw-mr-2" fab text x-small :title="$t('dashboard.help.show')" @click="showHelp(menu,page)">
            <span class="mr-1">
              <v-icon color="primary" x-small>fa fa-question</v-icon>
            </span>
      </v-btn>
    </template>
    <template #container>
      <div class="sr-container"></div>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"

export default {
  name: "Groups",
  mixins: [tab],
  data: () => ({
    //
  }),
  mounted() {
    this.reloadPreviousOpenedTab()
  },
}
</script>
